import { NgModule } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as AllIcon from 'angular-tabler-icons/icons';
import {environment} from '@env';

@NgModule({
  declarations: [],
  imports: [
    TablerIconsModule.pick(AllIcon,
      {

        // Ignore warnings, such as "Tabler Icon not found"
        ignoreWarnings: true,
        // ignoreWarnings: environment.production,

      })
  ],
  exports: [
    TablerIconsModule
  ]
})
export class TablerIconModule { }
